import { useLocation } from 'react-router-dom';
import 'src/style.css';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import HeaderUserbox from './Userbox';
import { useTour } from 'src/components/Tour';

interface HeaderProps {
  collapsed: boolean;
  onToggle: () => void;
  dark: boolean;
  onToggleTheme: () => void;
}

const pageTitle = (pathname: string): string => {
  if (pathname.includes('annotate')) return 'Document Annotator';
  if (pathname.includes('/folder') || pathname.includes('/files'))
    return 'Documents';
  if (pathname.includes('/image/view') || pathname.includes('image-view'))
    return 'Image Review';
  if (pathname.includes('/views') || pathname.includes('/view/'))
    return 'Document Review';
  if (pathname.includes('/rules')) return 'Dictionary';
  if (pathname.includes('editorial-guideline')) return 'Editorial Guideline';
  if (pathname.includes('copyPaste')) return 'Paste Text';
  if (pathname.includes('/image/')) return 'Process Image';
  if (pathname.includes('search-image')) return 'Search Image';
  if (pathname.includes('smart-search')) return 'Smart Search';
  if (pathname.includes('user-management')) return 'User Management';
  if (pathname.includes('activity-logs')) return 'Activity Logs';
  if (pathname.includes('tag-management')) return 'Tags Management';
  if (pathname.includes('letter-search')) return 'US Letter Search';
  if (pathname.includes('/irs')) return 'International Regulatory Search';
  if (pathname.includes('login-logs')) return 'Login Logs';
  if (pathname.includes('change-logs')) return 'Change Logs';
  if (pathname.includes('/features')) return 'Features';
  if (pathname.includes('setting')) return 'Settings';
  return 'Dashboard';
};

function Header({ collapsed, onToggle, dark, onToggleTheme }: HeaderProps) {
  const { pathname } = useLocation();
  const { startTour, highlightTour } = useTour();
  return (
    <header className="kshell-header">
      <div className="kshell-header-left">
        <button
          className="kshell-iconbtn"
          onClick={onToggle}
          aria-label="Toggle sidebar"
          title="Toggle sidebar"
        >
          {collapsed ? <MenuRoundedIcon /> : <MenuOpenRoundedIcon />}
        </button>
        <h1 className="kshell-pagetitle">{pageTitle(pathname)}</h1>
      </div>
      <div className="kshell-header-right">
        {/* Always-available entry point to the guided walkthrough — the
            once-per-login prompt is easy to dismiss, so users need a way back
            in. Starting it from another page routes to the tour's page first. */}
        <button
          className={`kshell-tourbtn${highlightTour ? ' is-attn' : ''}`}
          onClick={() => startTour()}
          aria-label="Start guided tour"
          title="Start guided tour"
        >
          <ExploreOutlinedIcon />
          <span>Start tour</span>
        </button>
        <button
          className="kshell-iconbtn"
          onClick={onToggleTheme}
          aria-label="Toggle theme"
          title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {dark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
        </button>
        <div className="kshell-userbox">
          <HeaderUserbox />
        </div>
      </div>
    </header>
  );
}

export default Header;
